<template>
  <div class="flex flex-wrap mb-2">
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6" style="position:relative">
      <!-- <loading :active="!this.showMarketingDate"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="false"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
      </loading> -->
      <!-- <span class="text-red-500">*</span> -->
      <span class="text-grap-700 align-middle">{{lang['components']['Event']['MarketingDate']['title']}}</span>
      <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'tooltip'"></i> -->
      <button
        v-if="!editPageType"
        id="marketingDate"
        class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
        @click="teachVideo()"
      >
        {{lang['components']['Event']['MarketingDate']['video_teaching']}}
      </button>
      <div class="flex-1 space-y-4">
        <div class="space-y-2">
          <div>
            <span class="text-red-500">*</span>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['MarketingDate']['start_date_title']}}</span>
            <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['MarketingDate']['start_date_title_info']}`"></i>
          </div>
          <div class="flex space-x-2">
            <div
              class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-48 calendar-group">
              <Calendar v-model="viewDatalistData.start_date" :monthNavigator="true" :yearNavigator="true" yearRange="2000:2030" dateFormat="yy-mm-dd" :minDate="startMinDate" :disabled="editPageType" />
              <span class="text-xs text-gray-400 w-24">(UTC＋8)</span>
            </div>
            <div
              class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-40 calendar-group" v-if="false">
              <Calendar v-model="starttime" :showTime="true" :timeOnly="true" />
              <span class="text-xs text-gray-400">(UTC＋8)</span>
            </div>
          </div>
        </div>
        <div class="space-y-2">
          <div class="flex flex-wrap items-center gap-2">
            <div>
              <span class="text-red-500">*</span>
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['MarketingDate']['end_date_title']}}</span>
            </div>
            <div class="text-grap-700 align-middle text-sm ml-auto lg:ml-28 flex items-center">
              <InputSwitch :disabled="editPageType" v-model="viewDatalistData.use_end_date" />
              <span class="mx-1">{{lang['components']['Event']['MarketingDate']['no_end_date']}}</span>
            </div>
          </div>
          <div class="flex space-x-2">
            <div
              class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-48 calendar-group">
              <Calendar v-model="viewDatalistData.end_date" :monthNavigator="true" :yearNavigator="true" yearRange="2000:2030" dateFormat="yy-mm-dd" :minDate="endMinDate" :disabled="viewDatalistData.use_end_date || editPageType ? '': isdisabled" />
              <span class="text-xs text-gray-400 w-24">(UTC＋8)</span>
            </div>
            <div
              class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-40 calendar-group" v-if="false">
              <Calendar v-model="endtime" :showTime="true" :timeOnly="true" />
              <span class="text-xs text-gray-400">(UTC＋8)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import Calendar from 'primevue/calendar';
  import InputSwitch from 'primevue/inputswitch';
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'

  export default {
    name: 'MarketingDate',
    props: {
      showMarketingDate: {
        type: Boolean
      },
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      },
      efficientAi: {
        type: Boolean
      }
    },
    components: {
      Calendar,
      InputSwitch,
      Loading
    },
    data() {
      return {
        // start: '08/11/2021',
        // end: '08/31/2021',
        starttime: null,
        endtime: null,
        useEndDate: false,
        isdisabled:false,
        startMinDate: null,
        endMinDate: null,
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=VMMjP-UF6BY",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
      }
    },
    created() {
      let setTime = new Date();
      let toDay = setTime.setDate(setTime.getDate() + 1);
      setTime = new Date(toDay);
      let nowDay = setTime.getDate();
      let nowMonth = setTime.getMonth();
      let nowYear = setTime.getFullYear();
      // this.startMinDate = new Date();
      // this.startMinDate.setMonth(nowMonth);
      // this.startMinDate.setFullYear(nowYear);
      // this.startMinDate.setDate(nowDay);

      this.startMinDate = setTime

    //  console.log('this.startMinDate');
    //  console.log(this.startMinDate);
    //  console.log('setTime');
    //  console.log(setTime);
    //  console.log('nowDay');
    //  console.log(nowDay);
    //  console.log('nowMonth');
    //  console.log(nowMonth);
    //  console.log('nowYear');
    //  console.log(nowYear);
    },
    watch:{
      'youtubeClose':function(v){
      //  console.log('marketingmethod youtubeClose');
      //  console.log(v);

        let _tmpYoutubeType = v.split('_');

      //  console.log('_tmpYoutubeType');
      //  console.log(_tmpYoutubeType);

      //  console.log(typeof this.view_youtube);
      //  console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'date'){
            this.view_youtube = false
          }
        }

      //  console.log(typeof this.view_youtube);
      //  console.log(this.view_youtube);
      },
      'viewDatalistData.start_date': function(v){
      //  console.log('viewDatalistData.start_date:'+v);
        if(v != '' && v != null){
          let setTime = new Date(v);
          let dateNum = 13;
          if(this.efficientAi == true){
            dateNum = 29;
          }
          let toDay = setTime.setDate(setTime.getDate() + dateNum);
          setTime = new Date(toDay);
          let lastDay = setTime.getDate();
          let lastMonth = setTime.getMonth();
          let lastYear = setTime.getFullYear();
          // this.endMinDate = new Date();
          // this.endMinDate.setMonth(lastMonth);
          // this.endMinDate.setFullYear(lastYear);
          // this.endMinDate.setDate(lastDay);

        //  console.log('this.endMinDate');
        //  console.log(this.endMinDate);

          this.endMinDate = setTime
          this.viewDatalistData.end_date = '0000-00-00'

          let startTime = v;
          let endTime = this.viewDatalistData.end_date;
          let diffType = 'day';

          // console.log('startTime:'+startTime);
          // console.log('endTime:'+endTime);

          // startTime = startTime.replace(/\-/g, "/");
          // endTime = endTime.replace(/\-/g, "/");
          //將計算間隔類性字符轉換為小寫
          let gapTime = 0;

          if(endTime != '' && endTime != null){
            diffType = diffType.toLowerCase();
            var sTime =new Date(startTime); //開始時間
            var eTime =new Date(endTime); //結束時間
            //作為除數的數字
            var timeType =1;
            switch (diffType) {
                case"second":
                    timeType =1000;
                break;
                case"minute":
                    timeType =1000*60;
                break;
                case"hour":
                    timeType =1000*3600;
                break;
                case"day":
                    timeType =1000*3600*24;
                break;
                default:
                break;
            }
            gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
          }

          // console.log('start_date 天數差：'+gapTime);

          this.$emit('childGapTime', gapTime);
        }
      },
      'viewDatalistData.end_date': function(v){
      //  console.log('viewDatalistData.end_date:'+v);
        this.$emit('childEndTime', v);

        if(v != '' && v != null){
          // this.GetDateDiff(this.startMinDate, v, 'day');

          let startTime = this.viewDatalistData.start_date;
          let endTime = v;
          let diffType = 'day';

          // console.log('startTime:'+startTime);
          // console.log('endTime:'+endTime);

          // startTime = startTime.replace(/\-/g, "/");
          // endTime = endTime.replace(/\-/g, "/");
          //將計算間隔類性字符轉換為小寫
          let gapTime = 0;

          if(startTime != '' && startTime != null){
            diffType = diffType.toLowerCase();
            var sTime =new Date(startTime); //開始時間
            var eTime =new Date(endTime); //結束時間
            //作為除數的數字
            var timeType =1;
            switch (diffType) {
                case"second":
                    timeType =1000;
                break;
                case"minute":
                    timeType =1000*60;
                break;
                case"hour":
                    timeType =1000*3600;
                break;
                case"day":
                    timeType =1000*3600*24;
                break;
                default:
                break;
            }
            gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
          }

          // console.log('end_date 天數差：'+gapTime);

          this.$emit('childGapTime', gapTime);
          // let setTime = new Date(v);
          // let toDay = setTime.setDate(setTime.getDate() + 14);
          // setTime = new Date(toDay);
          // let lastDay = setTime.getDate();
          // let lastMonth = setTime.getMonth();
          // let lastYear = setTime.getFullYear();
          // this.endMinDate = new Date();
          // this.endMinDate.setMonth(lastMonth);
          // this.endMinDate.setFullYear(lastYear);
          // this.endMinDate.setDate(lastDay);
        }
      },
      'viewDatalistData.use_end_date': function(value){
        // console.log('viewDatalistData.use_end_date:'+value);
        this.$emit('childUseEndDate', value);

        if(value == true){
          this.viewDatalistData.end_date = '0000-00-00';
        }
      },
      'efficientAi': function(v){
        // if(v != '' && v != null){
          let setTime = new Date(this.viewDatalistData.start_date);
          let dateNum = 13;
          if(this.efficientAi == true){
            dateNum = 29;
          }
          let toDay = setTime.setDate(setTime.getDate() + dateNum);
          setTime = new Date(toDay);
          let lastDay = setTime.getDate();
          let lastMonth = setTime.getMonth();
          let lastYear = setTime.getFullYear();
          // this.endMinDate = new Date();
          // this.endMinDate.setMonth(lastMonth);
          // this.endMinDate.setFullYear(lastYear);
          // this.endMinDate.setDate(lastDay);

        //  console.log('efficientAi this.endMinDate');
        //  console.log(this.endMinDate);

          this.endMinDate = setTime
          this.viewDatalistData.end_date = '0000-00-00'

          // let startTime = v;
          // let endTime = this.viewDatalistData.end_date;
          // let diffType = 'day';

          // console.log('startTime:'+startTime);
          // console.log('endTime:'+endTime);

          // startTime = startTime.replace(/\-/g, "/");
          // endTime = endTime.replace(/\-/g, "/");
          //將計算間隔類性字符轉換為小寫
          // let gapTime = 0;

          // if(endTime != '' && endTime != null){
          //   diffType = diffType.toLowerCase();
          //   var sTime =new Date(startTime); //開始時間
          //   var eTime =new Date(endTime); //結束時間
          //   //作為除數的數字
          //   var timeType =1;
          //   switch (diffType) {
          //       case"second":
          //           timeType =1000;
          //       break;
          //       case"minute":
          //           timeType =1000*60;
          //       break;
          //       case"hour":
          //           timeType =1000*3600;
          //       break;
          //       case"day":
          //           timeType =1000*3600*24;
          //       break;
          //       default:
          //       break;
          //   }
          //   gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
          // }

          // // console.log('start_date 天數差：'+gapTime);

          // this.$emit('childGapTime', gapTime);
        // }
      }
      // 'useEndDate': function(value){
      // //  console.log('useEndDate:'+value);
      // }
    },
    methods: {
      onReady() {
      //  console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
      //  console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingDate');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_date')

        this.src = "https://www.youtube.com/watch?v=VMMjP-UF6BY"
        this.vars.start = 240
        this.vars.end = 283
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
      //  console.log(val)
      },
      doDragging(){
      //  console.log('doDragging');
      },
      // GetDateDiff(startTime, endTime, diffType) {
      //     //將xxxx-xx-xx的時間格式，轉換為 xxxx/xx/xx的格式
      //     startTime = startTime.replace(/\-/g, "/");
      //     endTime = endTime.replace(/\-/g, "/");
      //     //將計算間隔類性字符轉換為小寫
      //     diffType = diffType.toLowerCase();
      //     var sTime =new Date(startTime); //開始時間
      //     var eTime =new Date(endTime); //結束時間
      //     //作為除數的數字
      //     var timeType =1;
      //     switch (diffType) {
      //         case"second":
      //             timeType =1000;
      //         break;
      //         case"minute":
      //             timeType =1000*60;
      //         break;
      //         case"hour":
      //             timeType =1000*3600;
      //         break;
      //         case"day":
      //             timeType =1000*3600*24;
      //         break;
      //         default:
      //         break;
      //     }
      //     return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
      // }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep(.calendar-group) {
    .p-calendar .p-inputtext {
      padding: 0.25rem;
      border: 0px;
    }
  }
</style>
<style type="text/css">
  .tiktok_cust .p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider, .tiktok_cust .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    background: #111827;
  }
</style>